<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="aviso">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs10 sm7 md5 lg4 elevation-6>
                <!-- Opción 1: ************************************ -->
                <v-card class="elevation-12 pa-4">
                    <v-card-text>
                        <v-container>
                            <v-layout row justify-center>
                                <v-flex xs12 class="text-center">
                                    <img :width="imgWidth" src="@/assets/catabocata1.png" />
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 class="text-center">
                                    <div
                                        class="text-center font-weight-bold subtitle-1 red--text text--darken-4"
                                    >
                                        En Catabocata nos preocupa el consumo responsable.
                                        <br />Por favor indica si tienes más de 18 años.
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap justify-center>
                                <v-flex xs10 sm8 md6 class="text-center">
                                    <v-btn
                                        color="red darken-4"
                                        class="text-none"
                                        text
                                        @click="onCancel"
                                    >Soy menor de 18 años</v-btn>
                                </v-flex>
                                <v-flex xs10 sm8 md6 class="text-center">
                                    <v-btn
                                        color="green darken-3"
                                        class="text-none"
                                        text
                                        @click="onOK"
                                    >Soy mayor de 18 años</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>

                <!-- Fin Opción 1 ************************************ -->

                <!-- Opción 2: ************************************ -->

                <!-- <v-container pa-0 grid-list-md>
                    <v-card class="elevation-12 pa-0">
                        <v-img
                            src="@/assets/stop.jpg"
                            class="align-end"
                            width="500"
                            gradient="to bottom, rgba(0,0,0,0), rgba(255,255,255,1)"
                        >
                            <v-card-text>
                                <v-container>
                                    <v-layout row justify-center>
                                        <v-flex xs12 class="text-center">
                                            <img width="250" src="@/assets/catabocata1.png" />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 class="text-center">
                                            <div
                                                class="text-center font-weight-bold subtitle-1 brown--text text--darken-4"
                                            >
                                                En Catabocata nos preocupa el consumo responsable.
                                                <br />Por favor indica si tienes más de 18 años.
                                            </div>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row wrap justify-center>
                                        <v-flex xs10 sm8 md6 class="text-center">
                                            <v-btn
                                                color="red darken-4"
                                                class="text-none"
                                                text
                                                @click="onCancel"
                                            >Soy menor de 18 años</v-btn>
                                        </v-flex>
                                        <v-flex xs10 sm8 md6 class="text-center">
                                            <v-btn
                                                color="green darken-3"
                                                class="text-none"
                                                text
                                                @click="onOK"
                                            >Soy mayor de 18 años</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-img>
                    </v-card>
                </v-container>-->

                <!-- Fin Opción 2 *********************************** -->
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            valid: false
        };
    },
    methods: {
        onOK() {
            this.$store.dispatch('updateAutorizado', true);
        },
        onCancel() {
            this.$store.dispatch('updateAutorizado', false);
        }
    },
    computed: {
        imgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '230px';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '250px';
            } else if (this.$vuetify.breakpoint.md) {
                width = '280px';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '320px';
            } else {
                width = '350px';
            }
            return width;
        }
    },
    created() {
        //this.$store.dispatch('tryAutoLogin');
    }
};
</script>

<style scoped>
.aviso {
    background: url('../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.tw-green {
    color: #00897b;
    /* teal darken-1 */
}

.tw-gray {
    color: #757575;
    /* grey darken-1 */
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>